import { baseUrl } from "./constants";
import {
  getToken,
  retreiveCachedResponse,
  cacheResponse
} from "./storage";

export async function getTool(barcode) {
  let data, rtn;

  try {
    if (barcode === "") {
      return {success: 0, data: "Please enter or scan the serial number"};
    }

    let token = await getToken();
    let response = await fetch(`${baseUrl}/tools/number/${barcode}`, {
      headers: {Authorization: `Bearer ${token}`}
    });

    let resData = await response.json();

    if (resData.success === 0) {
      rtn = {success: 0, data: resData.error.msg};
      new Error(resData.error);
    } else {
      data = resData.data;
      rtn = {success: 1, data};
      cacheResponse(`getTool:${barcode}`, data);
    }
  } catch (err) {
    if (
        err.message === "token_not_provided" ||
        err.message === "request_failed"
    )
      throw new Error(err.message);
    console.error(JSON.stringify(err));

    data = await retreiveCachedResponse(`getTool:${barcode}`);
  }

  return rtn;
}

export async function assignTool(toolId) {
  let token = await getToken();

  let response = await await fetch(`${baseUrl}/warehouse/assign/tool`, {
    method: "POST",
    body: JSON.stringify({
      tool_id: toolId
    }),
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  });

  return response;
}


// WEBPACK FOOTER //
// ./src/backend/tool.js